import React from "react";
import { connect } from "react-redux";
import { updateContentFeed } from "signoxe/actions";

class Widget extends React.PureComponent {
    getOrientation() {
        const profile = this.props.profile;
        console.log("Recent Data for open url func ", profile, this.props.feed);
        if (
            profile &&
            profile.features &&
            profile.features.UrlSetting === "True"
        ) {
            return this.props.feed.target_url;
        }

        return this.props.feed.target_url;
    }

    render() {
        const props = this.props;
        const profile = props.profile;
        const isTouchSettingEnabled =
            profile &&
            profile.features.UrlSetting === "True"
        return (
            <select
                name="orientation_select"
                id="orientation_select"
                title="Select an orientation"
                value={this.getOrientation()}
                onChange={(e) => {
                    this.props.setOrientation(e.currentTarget.value);
                }}
                disabled={isTouchSettingEnabled}
            >
                <option value="FULLSCREEN">Fullscreen</option>
                <option value="INTERACTED_REGION">Interacted Region</option>
                <option value="TOUCH_RECIEVER">Touch Receiver</option>
            </select>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setOrientation: (value) =>
            dispatch(updateContentFeed(ownProps.feed.id, { target_url: value })),
    };
};

export const OpenUrlSelectWidget = connect(
    mapStateToProps,
    mapDispatchToProps
)(Widget);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/OpenUrlSelectWidget/index.js